import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { invalidateSolarFinancingLockReaders } from "./solar-financing-lock-readers"
import type { SolarCreditHumanHandoffDto } from "../dto/solar-proposal-financing.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/**
 * Reopen the current application's hosted URL; nothing about the attempt changes.
 */
export default function useReopenSolarCreditHuman(): UseMutationResult<
  SolarCreditHumanHandoffDto,
  unknown,
  { proposalId: string; applicationId: string }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId, applicationId }) =>
      solarProposalService.reopenCreditHuman(proposalId, applicationId),
    // Fire and forget: the handoff tab waits on this mutation, so it must not
    // also wait on unrelated refetches.
    onSettled: (_data, _error, { proposalId }) => {
      invalidateSolarFinancingLockReaders(queryClient, proposalId)
    },
  })
}
